module.exports = __webpack_public_path__ + "static/media/Calibre-SemiboldItalic.8f3e4b3e.woff2";